export default [
  { value: 'ROLE_ADMIN', icon: 'LockIcon', label: 'Administrator' },
  { value: 'ROLE_MANAGER', icon: 'BriefcaseIcon', label: 'Manager' },
  { value: 'ROLE_TRAINER', icon: 'PenToolIcon', label: 'Trener' },
  { value: 'ROLE_EMPLOYEE', icon: 'UserIcon', label: 'Pracownik' },
  { value: 'ROLE_FORD_POLAND', icon: 'AwardIcon', label: 'Centrala' },
]
